import * as React from "react";

import { Card } from "../Card/Card";
import styles from "./TableCard.module.css";

export interface TableCardProps {
  children: React.ReactNode;
  /**
   * Клиппинг вместо горизонтального скролла (overflow: hidden).
   * Нужен для карточек без широкого содержимого — форм и карточных списков.
   * По умолчанию карточка скроллится: таблицы в макетах шире её.
   */
  clip?: boolean;
  className?: string;
}

export const TableCard: React.FC<TableCardProps> = ({ children, clip, className }) => (
  <Card
    className={`${styles.tableCard}${clip ? ` ${styles.clip}` : ``}${className ? ` ${className}` : ``}`}
  >
    {children}
  </Card>
);
